import { render } from "./PrimaryButton.vue?vue&type=template&id=7d45764d&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"

import "./PrimaryButton.vue?vue&type=style&index=0&id=7d45764d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d45764d"

export default script